
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tron-wallet-development",
      function () {
        return require("private-next-pages/tron-wallet-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tron-wallet-development"])
      });
    }
  